let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9eNkX")).then(() => parcelRequire('2OLbL'));